import { render, staticRenderFns } from "./QuadroHorarioGestaoPage.vue?vue&type=template&id=39028016&scoped=true"
import script from "./QuadroHorarioGestaoPage.vue?vue&type=script&lang=js"
export * from "./QuadroHorarioGestaoPage.vue?vue&type=script&lang=js"
import style0 from "./QuadroHorarioGestaoPage.vue?vue&type=style&index=0&id=39028016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39028016",
  null
  
)

export default component.exports